import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import RemoveDialog from "../../Components/RemoveDialog";
import useActiveContexts from "../useActiveContexts";

import * as api from "../../services";
import LibraryContext from "../libraryContext";
import AppContext from "../../appContext";

export default function LeaveContextDialog({ open, setOpen, id, contextName }) {
  const { t } = useTranslation();
  const { handleQuery } = useContext(LibraryContext);
  const {
    app: {
      project: { id: projectId },
      sessionId
    },
    dispatch,
  } = useContext(AppContext);
  const { refetchContexts } = useActiveContexts();

  const leaveMutation = useMutation(
    () =>
      api.setContextStatus({
        id,
        left: 1,
        projectId,
        sessionId
      }),
    {
      onSuccess: (data) => {
        if (data.data?.status === 1) {
          refetchContexts();
          dispatch({
            type: "UPDATE_CLIENTS",
            payload: new Date(),
          }); // trigger clients list to refresh
          handleQuery({ type: "navButtonClick", payload: "contexts" });
        }
      },
    }
  );

  return (
    <div>
      <RemoveDialog
        open={open}
        setOpen={setOpen}
        removeFunction={() => leaveMutation.mutate()}
        dialogTitle={t("library.leaveDialog.title")}
        dialogContentText={t("library.leaveDialog.text", {
          group: contextName,
        })}
        dialogActionCancel={t("common.actions.cancel")}
        dialogActionConfirm={t("library.leaveDialog.confirm")}
      />
    </div>
  );
}
